const rightsQueryKeys = {
  list: (asAcExpo?: boolean) => ["rights-list", asAcExpo ?? false],
};

export default rightsQueryKeys;
